import { useTLang } from 'intl/intl';

export function useSOCardLang() {
  return {
    scheduledTag: useTLang({ id: 'scheduleOrder.scheduledTag' }),
    orderIdLabel: useTLang({ id: 'scheduleOrder.orderIdLabel' }),
  };
}
